export const preRequisitesDocumentList = "PREREQUISITES_DOCUMENT_LIST";
